import { render, staticRenderFns } from "./project_tabs.vue?vue&type=template&id=5b269382&"
import script from "./project_tabs.vue?vue&type=script&lang=js&"
export * from "./project_tabs.vue?vue&type=script&lang=js&"
import style0 from "./project_tabs.vue?vue&type=style&index=0&id=5b269382&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports